import { render, staticRenderFns } from "./TagsShowTableAbstract.vue?vue&type=template&id=ecf9f516&"
import script from "./TagsShowTableAbstract.vue?vue&type=script&lang=js&"
export * from "./TagsShowTableAbstract.vue?vue&type=script&lang=js&"
import style0 from "./TagsShowTableAbstract.vue?vue&type=style&index=0&id=ecf9f516&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports